import { Box,Button } from "@mui/material";
import "./titleBox.css";
import { Link } from "react-router-dom";
import { logEvent } from "../../../utils/analytics";

function TitleBox(props) {

  return (
    <Box className="common-box">
      {/* Header Section */}
        <Box className="common-box-header">
            {props.title}
        </Box>
      {props?.subcontent && 
        <Box  class='common-box-subcontent'>
          {props?.subcontent}
        </Box>}

      {/* Content Section */}
      <Box className="common-box-content">{props.content}</Box>
        {
          props.buttonLabel && 
          <Box className="bottom-more">
              <Button
                component={Link}
                className="text-white"
                variant="contained"
                color="primary"
                to={props?.buttonLink}
                onClick={() => {
                  logEvent("Home Page News", "View All news button Clicked");
                }}
              >{props?.buttonLabel}
              </Button>
          </Box>
        }
      </Box>
  );
}
export default TitleBox;
